export const isEmpty = (value: any) => {
  if (Array.isArray(value)) {
    return value.length === 0;
  }
  if (value.constructor === Object) {
    return Object.keys(value).length === 0;
  }

  return false;
};
